import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionReveal } from '../SectionReveal';
import { PAIN_POINTS } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-carbon" aria-labelledby="pain-heading" data-id="element-165">
      <SectionReveal className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-166">
        <h2 id="pain-heading" className="mb-10 text-center font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-3xl" data-id="element-167">
          ❌ Si entrenás en Argentina, esto te va a sonar familiar
        </h2>
        <ul className="space-y-3" data-id="element-168">
          {PAIN_POINTS.map(point => <li key={point} className="group flex items-start gap-3 rounded-lg border border-transparent bg-transparent p-4 transition-colors duration-200 hover:border-orange hover:bg-carbon-3" data-id="element-169">
              <XIcon className="mt-0.5 h-5 w-5 flex-none text-red-500/80" aria-hidden="true" data-id="element-170" />
              <span className="text-muted group-hover:text-soft" data-id="element-171">{point}</span>
            </li>)}
        </ul>
        <p className="mt-12 text-center font-heading text-2xl font-bold leading-snug text-soft sm:text-3xl" data-id="element-172">
          ¿Cuántos entrenamientos más vas a tirar a la basura{' '}
          <span className="underline decoration-orange decoration-4 underline-offset-8" data-id="element-173">
            por no saber recuperarte?
          </span>
        </p>
      </SectionReveal>
    </section>;
}